const Loading = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-4">
      <svg
        className="animate-spin h-10 w-10 mr-3 text-[#2BB4D4]" // Add text color class here
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        />
      </svg>
      <h1 className="text-center">Loading ...</h1>{' '}
    </div>
  );
};

export default Loading;
